import Ajax from '@/lib/ajax'

export default {
  getAll() {
    return Ajax.get('/api/productManagement/productAttributeCategory/all')
  },
  deleteById(id: string | number) {
    return Ajax.delete(
      `/api/productManagement/productAttributeCategory?id=${id}`
    )
  },
  edit(id: string | number, editData: any) {
    let ajaxType = id ? 'put' : 'post'
    let ajaxUrl = id
      ? `/api/productManagement/productAttributeCategory/${id}`
      : '/api/productManagement/productAttributeCategory'
    return Ajax[ajaxType](ajaxUrl, editData)
  },
  getDataById(id: string | number) {
    return Ajax.get(`/api/productManagement/productAttributeCategory/${id}`)
  },
  getList(pageSize: number, currentPage: number) {
    return Ajax.get('/api/productManagement/productAttributeCategory', {
      params: {
        MaxResultCount: pageSize,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize
      }
    })
  }
}
